import React, { useEffect, useState } from "react";

const CDN_URL = process.env.REACT_APP_CDN_URL;
const download = `${CDN_URL}billing/Billing_INV_Download.svg`;

const Download = ({ width, invoiceId, downloadPdf }) => {
  const [invoiceData, setInvoiceData] = useState(null);

  useEffect(() => {
    if (invoiceId) {
      const getInvoiceById = (id) => {
        const invoicesData = sessionStorage.getItem("invoices");

        if (!invoicesData) {
          console.log("No invoices found in sessionStorage");
          return null;
        }

        try {
          const invoices = JSON.parse(invoicesData);
          const matchingInvoice = invoices.find(
            (inv) => inv.invoiceId === id || inv.id === id
          );

          return matchingInvoice || null;
        } catch (error) {
          console.error("Error parsing invoices from sessionStorage:", error);
          return null;
        }
      };

      const foundInvoice = getInvoiceById(invoiceId);
      if (foundInvoice) {
        setInvoiceData(foundInvoice);
      }
    }
  }, [invoiceId]);

  return (
    <div className="download">
      <img
        src={download}
        width={width}
        onClick={() =>
          downloadPdf(
            invoiceData?.invoiceId || invoiceId,
            invoiceData?.type,
            invoiceData?.docId
          )
        }
      />
    </div>
  );
};

export default Download;
